import { Component, OnChanges, Input, ViewChild, Output, EventEmitter  } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { DataService } from '../../shared/dataservice.service';
import { GenService } from '../../shared/gen-ser.service';
import { NotificationsService } from 'angular2-notifications';
import { DailyProdHighlights,DailyTokenItem,DailyToken, GreenStickerPlan, DPHToken, MaterialGembaCard, MaterialToken } from '../../shared/misc-classes';

@Component({
  selector: 'app-material-app-new',
  templateUrl: './material-app-new.component.html',
  styleUrls: ['./material-app-new.component.css']
})
export class MaterialAppNewComponent implements OnChanges {
  dateSel :number = 0;  
  mId:string ="";
  selDate:Date = new Date();
  @Input() selMonth: number;
  @Input() selProductType: string;
  materialData:any;
  // @Input() data: any;
  @Output() updateData = new EventEmitter<any>();
  fieldSelection:any;
  selectedSection:any;
  comments:any;
  dProdHighObj: DailyProdHighlights;
  mergeObj:MaterialGembaCard;
  greenSticPlanMonthly:GreenStickerPlan;
  materialShortageObj:Array<MaterialToken>;

  @ViewChild('childModal') public childModal:ModalDirective;
  constructor(public _dataService:DataService,private _notify:NotificationsService) {

    
   }

  ngOnChanges() {
    this.loadDailyProdData();
  }
  getDateFormatStr(_date, _format){
    switch(_format){
        case "DD":
            return _date.getDate();
    }
  return ''
  }
  loadDailyProdData(){
    this.materialData = [];
    this._dataService.getMaterialGembaCardData(new Date(this.selMonth), this.selProductType).subscribe((_tmpIssues:Array<MaterialToken>) => {
      if(_tmpIssues!=null){
          this.materialShortageObj = _tmpIssues;
          this.createMaterialData();
      }
    })
  }
  // loadGreenStkrData(){
  //   this._dataService.loadGreenStickerPlan(new Date(this.selMonth)).subscribe((_cstInspPlan: GreenStickerPlan) => {
  //     if (_cstInspPlan != null) {
  //       this.greenSticPlanMonthly = _cstInspPlan;
  //       this.mergeData();
  //     }
  //   });
  // }
  // mergeData(){
  //  this.mergeObj = new MaterialGembaCard(this.dProdHighObj.id,this.dProdHighObj.monthDateNum,this.dProdHighObj.plan,[]);
  //  if(this.dProdHighObj.dayTokens){ 
  //  for(var w=0;w<this.dProdHighObj.dayTokens.length;w++){
  //     for(var h=0; h<this.dProdHighObj.dayTokens[w].dateTokens.length;h++){
  //       var _tmp1 = this.dProdHighObj.dayTokens[w].dateTokens[h];
  //       if(_tmp1.productType == this.selProductType){
  //         if(this.mergeObj.dayTokens.length == 0){
  //           this.mergeObj.addDateToken(this.dProdHighObj.dayTokens[w].selDate,new MaterialToken(_tmp1.rowId,_tmp1.productId,_tmp1.productType,_tmp1.customerId,_tmp1.quantity,_tmp1.shortage,_tmp1.status,_tmp1.creationDate,_tmp1.shortageNotes,_tmp1.severityValue))
  //         }
  //         else{
  //           var dateMatched = false;
  //           for(var v=0;v<this.mergeObj.dayTokens.length;v++){
  //             if(this.mergeObj.dayTokens[v].selDate == this.dProdHighObj.dayTokens[w].selDate){
  //               dateMatched = true;
  //               let temp:MaterialToken;
  //               temp = (new MaterialToken(_tmp1.rowId,_tmp1.productId,_tmp1.productType,_tmp1.customerId,_tmp1.quantity,_tmp1.shortage,_tmp1.status,_tmp1.creationDate,_tmp1.shortageNotes,_tmp1.severityValue))
  //               this.mergeObj.dayTokens[v].addToken(temp)
  //             }             
              
  //           }
  //           if(dateMatched == false){
  //               this.mergeObj.addDateToken(this.dProdHighObj.dayTokens[w].selDate,new MaterialToken(_tmp1.rowId,_tmp1.productId,_tmp1.productType,_tmp1.customerId,_tmp1.quantity,_tmp1.shortage,_tmp1.status,_tmp1.creationDate,_tmp1.shortageNotes,_tmp1.severityValue))
  //           }
  //         }
         
  //       }
  //     }
  //   }
  // }
   
  //   for(var i=0;i< this.greenSticPlanMonthly.dayTokens.length;i++){
  //     var isFound = false;
  //     for(var a=0;a< this.mergeObj.dayTokens.length;a++){
  //       if(this.greenSticPlanMonthly.dayTokens[i].selDate == this.mergeObj.dayTokens[a].selDate){
  //         isFound = true;
  //         for(var j=0;j<this.greenSticPlanMonthly.dayTokens[i].dateTokens.length;j++){
  //           var _tmp = this.greenSticPlanMonthly.dayTokens[i].dateTokens[j];
  //             if(_tmp.productType == this.selProductType){
  //             this.mergeObj.dayTokens[a].addToken(new MaterialToken(_tmp.rowId,_tmp.productName,_tmp.productType,_tmp.customerName,_tmp.quantity,_tmp.shortage,_tmp.status,_tmp.creationDate,_tmp.shortageNotes,_tmp.severityValue))
              
  //           }
  //         }
  //       }
  //     }
  //     if(isFound == false){
  //       for(var h=0; h<this.greenSticPlanMonthly.dayTokens[i].dateTokens.length;h++){
  //         var _tmp = this.greenSticPlanMonthly.dayTokens[i].dateTokens[h];
  //         let temp:MaterialToken;
  //         if(_tmp.productType == this.selProductType){
  //           temp = (new MaterialToken(_tmp.rowId,_tmp.productName,_tmp.productType,_tmp.customerName,_tmp.quantity,_tmp.shortage,_tmp.status,_tmp.creationDate,_tmp.shortageNotes,_tmp.severityValue))
  //           this.mergeObj.addDateToken(this.greenSticPlanMonthly.dayTokens[i].selDate,temp)
  //         }
  //       }
  //     }
      
  //   }
    
  //   this.createMaterialData(this.mergeObj)
  // }
  createMaterialData(){
    let _tmpDailyTokenList: Array<any> = [];
        for (var i = 0; i < this.materialShortageObj.length; i++) {
          let  _tempArray = <any>{};
           _tempArray._selDate = this.getDateFormatStr(this.materialShortageObj[i].createdDate,"DD");
           _tempArray._selArray=[];
           let redFlag = false;
           let blueFlag = false;
           let greenFlag = false;
           let _tmpFlag;
          //  for(var a=0;a < prodHighObj.dayTokens[i].dateTokens.length; a++){
            if(this.materialShortageObj[i].severityValue == 1){
              blueFlag = true;
              var _tmp =<any>{};
                  _tmp.productId = this.materialShortageObj[i].productId;
                  _tmp.customerId = this.materialShortageObj[i].customerId;
                  _tmp.productType = this.materialShortageObj[i].productType;
                  _tmp.shortageNotes = this.materialShortageObj[i].shortageNotes;
                  _tempArray._selArray.push(_tmp);
            }
            else if(this.materialShortageObj[i].severityValue == 2){
              redFlag = true;
              var _tmp =<any>{};
                  _tmp.productId = this.materialShortageObj[i].productId;
                  _tmp.customerId = this.materialShortageObj[i].customerId;
                  _tmp.productType = this.materialShortageObj[i].productType;
                  _tmp.shortageNotes = this.materialShortageObj[i].shortageNotes;
                  _tempArray._selArray.push(_tmp)
            }
            else if(this.materialShortageObj[i].severityValue == null || this.materialShortageObj[i].severityValue == 3){
                greenFlag = true;
            }
          //  }
           
           if(redFlag){
            _tempArray._selFlag = 2
           }
           else if(blueFlag == true && redFlag == false){
            _tempArray._selFlag = 1;              
           }
           else if(blueFlag == false && redFlag == false && greenFlag == true){
            _tempArray._selFlag = 0;
           }
           else if(blueFlag == false && redFlag == false && greenFlag == false){
            _tempArray._selFlag = -1;
           }
           _tmpDailyTokenList.push(_tempArray)
           
        }
      this.materialData = _tmpDailyTokenList;
      }

  hasEditAccess(_pid:string){
    return this._dataService.hasEditAccess(this.mId,_pid);
  }
  openModal(num){
    this.selDate = new Date((new Date(this.selMonth)).setDate(num))
    this.fieldSelection={};
    this.fieldSelection.selArray=[];
    if(this.materialData){
        for(var i=0;i<this.materialData.length;i++){
           if(this.materialData[i]._selDate == num){
             for(var u=0;u<this.materialData[i]._selArray.length;u++){
               this.fieldSelection.selArray.push(this.materialData[i]._selArray[u]); 
             }            
            this.fieldSelection.flag = this.materialData[i]._selFlag;
           }
        }
    }

  this.childModal.show();
    
  }
  public hideChildModal():void {
    this.childModal.hide();
  }
  getProductType(type:string){
    if(type){
      return this._dataService.getProductType(type);
    }
  }
  formatMonth(_dateObj:string):string{
    let dateObj = new Date(_dateObj);
    if(dateObj){
      return GenService.getDateFormatStr(dateObj , "MMM-YYYY");
    }
    return '-';
  }
  addColor(num){
    var isFound = false;
    if(this.materialData && this.materialData.length>0){
        for(var i=0;i<this.materialData.length;i++){
          if(this.materialData[i]._selDate == num){
            isFound = true;
            if(this.materialData[i]._selFlag == 3){
                return 'green'
            }
            else if(this.materialData[i]._selFlag == 1){
              return 'blue'
            }
            else if(this.materialData[i]._selFlag == 2){
              return 'red'
            }
            else{
              return 'green'
            }       
          }
      }
    }
    if(!isFound){
      if(!this.selProductType)
        return 'white'
      else{
        var _tmpDate = new Date(this.selMonth);
        if(num < _tmpDate.getDate() && _tmpDate.getMonth() == new Date().getMonth() && _tmpDate.getFullYear() == new Date().getFullYear()){
          var day = new Date(_tmpDate.setDate(num)).getDay();
          if(day == 0 || day == 6)
              return 'white'
          else
              return 'green'
        }
        else if(_tmpDate.getMonth() < new Date().getMonth() && _tmpDate.getFullYear() <= new Date().getFullYear()){ 
          var day = new Date(_tmpDate.setDate(num)).getDay();
          if(day == 0 || day == 6)
            return 'white'
        else
          return 'green'
        }
        else if(_tmpDate.getMonth() > new Date().getMonth() && _tmpDate.getFullYear() < new Date().getFullYear()){ 
          var day = new Date(_tmpDate.setDate(num)).getDay();
          if(day == 0 || day == 6)
            return 'white'
        else
          return 'green'
        }
        else  
          return 'white'
      }
    }
  }


}
